define('modules/base/views/submenu.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette"
], function(Prospector, $,_,Backbone,
            Marionette
) {
    var SubMenuView = Marionette.LayoutView.extend({
        className: 'subMenu',
        initialize:function(options){
            this.parent = options.parent;
            this.currentView = "";
            Prospector.subMenu = this;
        },
        onRender:function(){
            var draw = window.utils.getQueryStringParameter(window.location.hash, 'draw');
            if((draw == null || draw == undefined) && this.parent != undefined){
                if(this.parent.drawer != undefined){
                    draw = this.parent.drawer;
                }
            }
            if(draw!= null){
                this.$('.'+draw).click();
            }
        },
        isOpen:function(){
            return $('#page-content-wrapper').hasClass('openTop');
        },
        showView:function(options){
            var app = options.type;
            var e = options.event;
            if(this.currentView != app){
                if(!this.isOpen() && (options.open == undefined || options.open)){
                    Prospector.trigger("openTopDrawer");
                }
                Prospector.trigger("fillTopDrawer", {view: options.view});
                this.$(".horizontalIcon").removeClass('active');
                if((options.open == undefined || options.open)) {
                    if (e != undefined) {
                        e.currentTarget.classList.add('active');
                    } else if (options.selector != undefined) {
                        $(options.selector).addClass('active');
                    }
                }
            } else {
                app = "";
                this.$(".horizontalIcon").removeClass('active');
                Prospector.trigger("closeTopDrawer");
            }
            if((options.open == undefined || options.open)){
                this.currentView = app;
            } else {
                this.currentView = "";
            }
        }
    });
    return SubMenuView;
});
